import React, { useEffect, useState } from 'react';
import axios from 'axios'
import Avatar from '@material-ui/core/Avatar';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation, useHistory } from "react-router-dom";
import jwt from 'jsonwebtoken'
import OnSubmitPayment from './OnSubmitPayment'
import Header from '../Element/Header'

function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '} {new Date().getFullYear()} {' '}
        <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
          Kawasan Industri Jababeka
        </Link>
        {'.'}
      </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
}));

function formatRupiah(angka, prefix) {
    let number_string = angka.replace(/[^,\d]/g, '').toString(),
        split = number_string.split(','),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
        let separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
    }

    rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
    return prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
}

export default function ConfirmPayment() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [bank, setBank] = useState([])
    const [sendBank, setSendBank] = useState([])
    const [fromBank, setFromBank] = useState([])
    const [fullname, setFullname] = useState('')
    const [email, setEmail] = useState('')
    const [viewRupiah, setViewRupiah] = useState('')
    const [transferAmount, setTransferAmount] = useState('')
    const [accNumber, setAccNumber] = useState('')
    const [accNumberName, setAccNumberName] = useState('')
    const [upload, setUpload] = useState('')
    const [Desc, setDesc] = useState('')
    const [paymentId, setPaymentId] = useState('')
    const [payment, setPayment] = useState('')

    useEffect(async () => {
        const fetchData = async () => {
            const result = await axios(
                `${process.env.REACT_APP_API}/participant/bank`,
            );

            setBank(result.data);
        };
        let token = location.pathname.split('/')[3]
        let decoded = jwt.verify(token, process.env.REACT_APP_SECRET);
        setFullname(decoded.name)
        setEmail(decoded.email)
        setPaymentId(decoded.payment_id)
        

        const getData = async () => {
            const result = await axios.post(
                `${process.env.REACT_APP_API}/participant/read`, {
                email: decoded.email
            })

           
            setPayment(result.data)
        }

        getData();
        fetchData();
    }, [location]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleChangeSendBank = (event) => {
        setSendBank(event.target.value);
    };

    const handleChangeFromBank = (event) => {
        setFromBank(event.target.value);
    };

    const handleViewRupiah = (event) => {
        setTransferAmount(event.target.value)
        let format = formatRupiah(event.target.value)
        setViewRupiah(format);
    };

    const handleChangeAccNumber = (event) => {
        setAccNumber(event.target.value)
    }

    const handleChangeAccNumberName = (event) => {
        setAccNumberName(event.target.value)
    }

    const handleChangeUpload = (event) => {
        setUpload(event.target.files[0])
    }

    const handleChangeDesc = (event) => {
        setDesc(event.target.value)
    }

    console.log(payment)
    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                {/* <Avatar alt="Job Fair Logo" src="/participant/logo512.png" variant="square" className={classes.large} /> */}
                {/* <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6">
                    VIRTUAL JOB FAIR 2021
                </Typography> */}
                <Header />
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <form className={classes.form} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="namalengkap"
                            label="Nama Lengkap"
                            name="namalengkap"
                            autoComplete="namalengkap"
                            disabled
                            value={fullname}
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            disabled
                            value={email}
                            size="small"
                        />
                        <KeyboardDatePicker
                            disableToolbar
                            fullWidth
                            required
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="Tanggal Transfer"
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="send_bank"
                            label="Transfer Ke"
                            name="send_bank"
                            autoComplete="send_bank"
                            autoFocus
                            disabled
                            value="1560017777998"
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="name_bank"
                            label="Bank"
                            name="name_bank"
                            autoComplete="name_bank"
                            autoFocus
                            disabled
                            value="Mandiri"
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="nominal"
                            label="Nominal"
                            name="nominal"
                            autoComplete="nominal"
                            autoFocus
                            disabled
                            value={payment.payment_total}
                            size="small"
                        />
                        {/* <FormControl variant="outlined" className={classes.formControl} fullWidth>
                            <InputLabel id="send_bank" required>Transfer Ke</InputLabel>
                            <Select
                                labelId="send_bank"
                                id="send_bank"
                                value={sendBank}
                                onChange={handleChangeSendBank}
                                label="Transfer Ke"
                            >
                                {
                                    bank.map((value, index) => {
                                        return (
                                            <MenuItem key={value.id} value={value}>{value.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl> */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="jumlahtransfer"
                            label="Jumlah Transfer"
                            name="jumlahtransfer"
                            autoComplete="jumlahtransfer"
                            autoFocus
                            onChange={handleViewRupiah}
                            value={viewRupiah}
                            size="small"
                        />
                        <FormControl variant="outlined" className={classes.formControl} fullWidth size="small">
                            <InputLabel id="from_bank" required>Transfer dari</InputLabel>
                            <Select
                                labelId="from_bank"
                                id="from_bank"
                                value={fromBank}
                                onChange={handleChangeFromBank}
                                label="Transfer dari"
                            >
                                {
                                    bank.map((value, index) => {
                                        return (
                                            <MenuItem key={value.id} value={value}>{value.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="no_rek"
                            label="No. Rekening"
                            name="no_rek"
                            autoComplete="no_rek"
                            autoFocus
                            onChange={handleChangeAccNumber}
                            value={accNumber}
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="atas_nama"
                            label="Atas Nama"
                            name="atas_nama"
                            autoComplete="atas_nama"
                            autoFocus
                            onChange={handleChangeAccNumberName}
                            value={accNumberName}
                            size="small"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="keterangan"
                            label="keterangan"
                            name="Keterangan"
                            autoComplete="keterangan"
                            autoFocus
                            onChange={handleChangeDesc}
                            value={Desc}
                            size="small"
                        />
                        <Button
                            variant="outlined"
                            component="label"
                            fullWidth
                        >
                            Bukti Transfer
                            <input
                                type="file"
                                hidden
                                onChange={handleChangeUpload}
                                accept="image/*"
                            />
                        </Button>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.submit}
                            onClick={() => OnSubmitPayment(fullname, email, selectedDate, sendBank, viewRupiah, fromBank, accNumber, upload, Desc, history, paymentId, accNumberName)}
                        >
                            KONFIRMASI PEMBAYARAN
                        </Button>
                    </form>
                </MuiPickersUtilsProvider>
            </div>
            <Box mt={2} mb={5}>
                <Copyright />
            </Box>
        </Container>
    );
}